import { useEffect, useState } from "react";
import {
  readEffectiveTopAnnouncementVisible,
  readTopAnnouncementDismissed,
  TOP_ANNOUNCEMENT_BAR_VISIBILITY_EVENT,
  type TopAnnouncementVisibilityDetail,
} from "@/lib/layout/top-announcement-bar";

/**
 * Whether the rotating top announcement bar is shown (not dismissed).
 * Synced via custom event when user dismisses the bar or when mobile hides it.
 */
export const useTopAnnouncementVisible = (): boolean => {
  const [visible, setVisible] = useState(() => readEffectiveTopAnnouncementVisible());

  useEffect(() => {
    const syncFromRules = () => {
      setVisible(readEffectiveTopAnnouncementVisible());
    };

    const handleVisibility = (event: Event) => {
      const custom = event as CustomEvent<TopAnnouncementVisibilityDetail>;
      if (typeof custom.detail?.visible === "boolean") {
        setVisible(custom.detail.visible);
        return;
      }
      syncFromRules();
    };

    syncFromRules();
    window.addEventListener(TOP_ANNOUNCEMENT_BAR_VISIBILITY_EVENT, handleVisibility);
    window.addEventListener("resize", syncFromRules);
    window.addEventListener("orientationchange", syncFromRules);

    return () => {
      window.removeEventListener(TOP_ANNOUNCEMENT_BAR_VISIBILITY_EVENT, handleVisibility);
      window.removeEventListener("resize", syncFromRules);
      window.removeEventListener("orientationchange", syncFromRules);
    };
  }, []);

  return visible;
};

/** @internal re-export for tests */
export { readTopAnnouncementDismissed };
